export const ADDRESS = '404 Spring Creek Rd, Delano, TN 37325';
export const PARK_PHONE = '+14232630050';
export const CAMPSITE_LABEL =
  'Hiwassee Scenic River State Park — Gee Creek Campground, Group Site 6 — Delano, TN';

/**
 * Apple devices get a maps.apple.com link, which opens the Maps app directly.
 * Everything else gets Google Maps, which opens the app on Android and the web
 * map on a desktop browser.
 */
export function mapsUrl(): string {
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  // iPadOS 13+ reports "Macintosh", so this covers iPhone, iPad and Mac.
  const isApple = /iPhone|iPad|iPod|Macintosh/.test(ua);
  const query = encodeURIComponent(ADDRESS);

  return isApple
    ? `https://maps.apple.com/?q=${query}`
    : `https://www.google.com/maps/search/?api=1&query=${query}`;
}
